module.exports = __webpack_public_path__ + "static/media/ic_up_arrow_gold.44c854cf.svg";